import { isNullOrUndefined } from "src/utils/common-util";

export const NO_VALUE_PLACEHOLDER = "-";

interface IFormatNullableParams<T> {
    value: T | null | undefined;
    format: (value: T) => string;
}

export const formatNullable = <T>({ value, format }: IFormatNullableParams<T>): string =>
    isNullOrUndefined(value) ? NO_VALUE_PLACEHOLDER : format(value);
